import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { GameColorGalleryTreasureLocationDTO } from '@/api/DTO/treasury/gallery.interface';

interface Props {
	list: GameColorGalleryTreasureLocationDTO[];
	bgImage: string;
}

export default function ViewLocationDialog(props: Props) {
	const { list, bgImage } = props;
	console.log(list);
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const [imageList, setImageList] =
		useState<GameColorGalleryTreasureLocationDTO[]>(list);

	useEffect(() => {
		setImageList(list);
	}, [list]);

	const handleClose = () => {
		setOpen(false);
	};

	const formContent = (
		<>
			<Button
				style={{ alignItems: 'center', position: 'absolute', left: 24 }}
				endIcon={<VisibilityOutlinedIcon />}
				onClick={() => setOpen(true)}
			>
				{t('common.showImage')}
			</Button>
			<Dialog
				open={open}
				onClose={() => handleClose()}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				maxWidth='lg'
				fullWidth
			>
				<DialogTitle variant='h5'>{t('common.showImage')}</DialogTitle>
				<IconButton
					aria-label='close'
					onClick={() => handleClose()}
					sx={{
						position: 'absolute',
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
				<DialogContent>
					<Box sx={{ position: 'relative', height: '245px' }}>
						<img
							src={bgImage}
							width={245}
							height={245}
							style={{
								objectFit: 'contain',
								position: 'absolute',
								left: '50%',
								transform: `translateX(-50%)`,
								zIndex: 0,
							}}
						/>
						{imageList.map((item, index) => (
							<img
								key={item.layerSort}
								src={item?.treasurePositionPic?.url || ''}
								width={245}
								height={245}
								style={{
									objectFit: 'contain',
									position: 'absolute',
									left: '50%',
									transform: `translateX(-50%)`,
									zIndex: index,
								}}
							/>
						))}
					</Box>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => handleClose()}>{t('button.cancel')}</Button>
				</DialogActions>
			</Dialog>
		</>
	);
	return <>{formContent}</>;
}
